import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { saveWorkingProjectByFields } from '@/store/slices/project';
import { selectWorkingProject, selectWorkingProjectDefaultLanguage } from '@/store/slices/project/selectors';
import { selectFeedbackText } from '@/store/slices/settings/selectors';
import { updateTranslateKey } from '@/utils/update-translation-key';
import useLanguageParams from '@/utils/use-language-params';
import Container from '@ui/container/container';
import InputWithOverlay from '@ui/input-with-overlay/input-with-overlay';
import React, { useEffect, useState } from 'react';

const UserFeedbackSurveyText = ({ saving: savingParent }: { saving: boolean }) => {
  const feedbackText = useAppSelector(selectFeedbackText);
  const workingProject = useAppSelector(selectWorkingProject);
  const defaultLang = useAppSelector(selectWorkingProjectDefaultLanguage);
  const language = useLanguageParams() ?? 'en';
  const title = (feedbackText?.title?.[language] as string) || 'Do you like the show?';
  const [currentTitle, setCurrentTitle] = useState(title);
  const [savingSelf, setSavingSelf] = useState(savingParent);
  const dispatch = useAppDispatch();

  useEffect(() => {
    setCurrentTitle(title);
  }, [title]);

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentTitle(e.target.value);
  };

  const onSave = async () => {
    if (!workingProject) return;
    try {
      setSavingSelf(true);
      await dispatch(
        saveWorkingProjectByFields({
          settings: {
            ...workingProject.settings,
            feedback_survey_text: {
              title: updateTranslateKey({
                translateString: feedbackText?.title ?? currentTitle,
                input: currentTitle,
                language: language,
                baseLanguage: defaultLang ?? 'en',
              }),
            },
          },
        })
      );
    } catch (e) {
      console.error(e);
    } finally {
      setSavingSelf(false);
    }
  };

  return (
    <Container padding="16px 0 0 0">
      <div className="flex-column flex-1">
        <div className="flex ai-center jc-space-between margin-t--8">
          <InputWithOverlay
            wrapperClass="flex-1"
            typography="P2"
            designSize="small"
            design="GlobalIcoText3"
            inputHeight="32px"
            label="Question"
            inputProps={{
              tabIndex: 0,
              value: currentTitle,
              onChange: handleNameChange,
              placeholder: 'How did you like the show?',
              onBlur: onSave,
              disabled: savingParent || savingSelf,
            }}
          />
        </div>
      </div>
    </Container>
  );
};

export default UserFeedbackSurveyText;
